import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import API from '../../../../api/api'

import ParkingPaymentSuccess from './ParkingPaymentSuccess'

const PaymentSuccessRedirectToPage = () => {
  const navigate = useNavigate()
  const { ticketNumber } = useParams()

  useEffect(() => {
    ;(async () => {
      try {
        await API.getParkingTicket(ticketNumber)
      } catch {
        navigate('/parking/error/404')
      }
    })()
  }, [ticketNumber])

  return (
    <div className="parking-info">
      <ParkingPaymentSuccess ticketNumber={ticketNumber} />
    </div>
  )
}

export default PaymentSuccessRedirectToPage
